module.exports = __webpack_public_path__ + "static/media/LOGO LITTLE QUOKKA.02aa47d4.png";